import { CaseGranulometry } from '../../CaseGranulometry';
import { getCaseGroundLevelGeometryArea } from '../get/getCaseGroundLevelGeometryArea';

export const hasCaseGranulometryGroundLevelDrawnGeometry = (
  caseGranulometry: CaseGranulometry
): boolean => getCaseGroundLevelGeometryArea(caseGranulometry) !== undefined;
